// Import GSAP and plugins
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollSmoother from 'gsap/ScrollSmoother';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import { initializeAnimations } from './animations';
// Register GSAP plugins before DOMContentLoaded
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin);

// Wait for DOM to be fully loaded
document.addEventListener('DOMContentLoaded', () => {
	// Add smooth scroll class to html
	document.documentElement.classList.add('has-scroll-smooth');

	// Initialize ScrollSmoother
	ScrollSmoother.create({
		wrapper: '#smooth-wrapper',
		content: '#smooth-content',
		smooth: 1,
		effects: true,
		// lag: 0.5,
	});

	const resizeObserver = new ResizeObserver((entries) => {
		ScrollTrigger.refresh();
		// console.log(entries);
	});

	// start observing a DOM node
	resizeObserver.observe(document.body);

	initializeAnimations();

	// Initialize scroll-to functionality for navigation links
	initializeScrollToLinks();

	// Initialize mobile nav toggle
	initializeNavToggle();
});

// Toggle mobile navigation: add/remove `.is-open` on `.primary-nav`, toggle `.hamburger` and prevent body scroll
function initializeNavToggle() {
	const nav = document.querySelector('.primary-nav');
	if (!nav) return;

	const toggle = nav.querySelector('.toggle-nav');
	const hamburger = nav.querySelector('.hamburger');
	if (!toggle) return;

	toggle.setAttribute('role', 'button');
	if (!toggle.hasAttribute('aria-expanded')) toggle.setAttribute('aria-expanded', 'false');

	toggle.addEventListener('click', (e) => {
		e.preventDefault();
		const isOpen = nav.classList.toggle('is-open');
		if (hamburger) hamburger.classList.toggle('is-open', isOpen);
		toggle.setAttribute('aria-expanded', String(isOpen));
		document.body.classList.toggle('no-scroll', isOpen);
		try { if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh(); } catch (err) {}
	});
}

// Function to initialize smooth scroll-to functionality for navigation links
function initializeScrollToLinks() {
	// Get all navigation links
	const navLinks = document.querySelectorAll('.primary-nav a[href^="#"]');

	navLinks.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();

			// If mobile menu is open, close it before scrolling
			const nav = document.querySelector('.primary-nav');
			if (nav && nav.classList.contains('is-open')) {
				nav.classList.remove('is-open');
				const toggle = nav.querySelector('.toggle-nav');
				const hamburger = nav.querySelector('.hamburger');
				if (hamburger) hamburger.classList.remove('is-open');
				if (toggle) toggle.setAttribute('aria-expanded', 'false');
				document.body.classList.remove('no-scroll');
				try { if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh(); } catch (err) {}
			}

			// Get the target section ID from the href attribute
			const targetId = link.getAttribute('href');
			console.log(targetId);

			const targetElement = document.querySelector(targetId);

			if (targetElement) {
				// Get the target element's position relative to the top of the window
				const rect = targetElement.getBoundingClientRect();
				const offsetFromTop = rect.top + window.pageYOffset;

				console.log(`Target: ${targetId}`);
				console.log(
					`Element offset from document top: ${offsetFromTop}px`
				);
				console.log(
					`Element current position from viewport top: ${rect.top}px`
				);
				console.log(`Current scroll position: ${window.pageYOffset}px`);

				const scrollMask = document.getElementById('scroll-mask');

				scrollMask.classList.add('active');

				const offset = 150; // Adjust this value for your desired offset from the target element
				gsap.to(window, {
					scrollTo: {
						y: targetElement,
						offsetY: offset,
						autoKill: true,
					},
					onComplete: () => {
						setTimeout(() => {
							scrollMask.classList.remove('active');
						}, 500);
					},
				});
			}
		});
	});
}
